import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {RouterModule} from '@angular/router';
import {CadensSharedModule} from '../../shared';
import {
    CalendarModule,
    InputTextModule,
    DataTableModule,
    SharedModule,
    MultiSelectModule,
    DialogModule,
    ConfirmDialogModule,
    RadioButtonModule
} from 'primeng/primeng';
import {
    CampagneService,
    CampagnePopupService,
    CampagneComponent,
    CampagneDetailComponent,
    CampagneDialogComponent,
    CampagnePopupComponent,
    campagneRoute,
    campagnePopupRoute
} from './';
import {CadensBlocksModule} from '../blocks/blocks.module';
import {
    CampagneFormationsDialogComponent,
    CampagneFormationsPopupComponent
} from './campagne-formations-dialog.component';

let ENTITY_STATES = [
    ...campagneRoute,
    ...campagnePopupRoute,
];

@NgModule({
    imports: [
        CadensSharedModule,
        CadensBlocksModule,
        InputTextModule,
        CalendarModule,
        DataTableModule, SharedModule,
        MultiSelectModule,
        DialogModule,
        ConfirmDialogModule,
        RadioButtonModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        CampagneComponent,
        CampagneDetailComponent,
        CampagneDialogComponent,
        CampagneFormationsDialogComponent,
        CampagneFormationsPopupComponent,
        CampagnePopupComponent,
    ],
    entryComponents: [
        CampagneComponent,
        CampagneDialogComponent,
        CampagnePopupComponent,
        CampagneFormationsDialogComponent,
        CampagneFormationsPopupComponent
    ],
    providers: [
        CampagneService,
        CampagnePopupService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CadensCampagneModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/campagne/campagne.module.ts